const reset = ({ eventName }) => {
  if (window.analytics) {
    window.analytics.reset();
  }
};

export default reset;
